// extracted by mini-css-extract-plugin
export var boxes = "boxes-module--boxes--2jGnY";
export var boxes__wrap = "boxes-module--boxes__wrap--19DBg";
export var boxes__box = "boxes-module--boxes__box--33uMP";
export var boxes__box__image = "boxes-module--boxes__box__image--y_6dv";